import swal from 'sweetalert2';
import trackProgress from '../utils/state/progress';
import {formatMoney} from "../utils/formatters";
import {createAjaxErrorHandler} from "../utils/error_handling";
import {totalsFill} from "../utils/fillers";

$(() => {
  function recalculateTotals({silent = false} = {}) {
    const $form = $('#total-estimator').find('form');

    if (!$form.length) {
      return;
    }

    const addressChoiceId = $form.find('[name="address_choice"]:checked').val();
    const countryId = $form.find('[name="country"]').val();
    const postalCode = $form.find('[name="postal_code"]').val();
    const city = $form.find('[name="city"]').val();
    const subdivision = $form.find('[name="subdivision"]').val();
    const shippingMethodId = $form.find('[data-checkout-input="shipping_method"]').val();

    trackProgress({
      name: 'Estimating total...',
      modal: false,
      promise: $.ajax({
        method: 'post',
        url: '/store/cart/totals/',
        data: $form.serialize(),
      }).then(totalsFill).then(() => {
        $('#total-estimator').modal('hide');
      }, (xhr, ...args) => {
        if (xhr.responseJSON && xhr.responseJSON.fields) {
          if (!silent) {
            swal({
              type: 'error',
              title: 'Problem Detected',
              text: xhr.responseJSON.errors[0],
            });
          }
        } else {
          return new Promise((accept, reject) => {
            reject(xhr, ...args);
          });
        }
      }).then(() => {
      }, createAjaxErrorHandler()),
    });
  }

  $(document).on('change', '[data-form="shopping-cart"] [name^="quantity_"]', event => {
    const $this = $(event.target);
    const $form = $this.closest('form');
    const url = $form.attr('action');
    let value = parseInt($this.val());
    const max = $this.attr('max');
    console.log(url, value, max);
    if (value <= 0 || isNaN(value)) {
      // The user is trying to remove the item... maybe?
      swal({
        text: 'Did you want to remove this item?',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove it!'
      }).then(result => {
        $this.val(event.target.defaultValue);
        if (result.value) {
          $this.closest('[data-order-item-id]').find('[name="remove"]').click();
        }
      });
    } else {
      // Make sure we don't exceed the max quantity
      if (value > max) {
        value = max;
        $this.val(value);
      }

      $.ajax({
        method: 'post',
        url: url,
        data: [
          ...$form.serializeArray(),
          {name: 'update', value: 'update'},
        ],
      }).then(data => {
        data.items.forEach(item => {
          const $row = $(`div[data-order-item-id="${item.id}"]`);
          const $subtotal = $row.find('[data-order-item-field="subtotal"]');
          const $quantity = $row.find(`[name="quantity_${item.id}"]`);
          $subtotal.addClass('text-muted');
          $quantity.val(item.quantity);
        });
        recalculateTotals({
          silent: true
        });
      }, err => {
        $('[data-form="shopping-cart"]').find('[name="update"]').show();
      });

      event.target.defaultValue = value;
    }
  });

  // Remove the quantity update buttons
  $('[data-form="shopping-cart"]').find('[name="update"]').hide();

  $('#total-estimator').find('form').on('submit', event => {
    event.preventDefault();
    recalculateTotals();
  });

  recalculateTotals({
    silent: true
  });
});